class LocalizationForm extends HTMLElement {
  constructor() {
    super();

    this.elements = {
      input: this.querySelector('input[name="language_code"], input[name="country_code"]'),
      button: this.querySelector('button'),
      panel: this.closest('[data-localization-wrapper]')
               ?.querySelector('.js-currency-switcher-content, .js-language-switcher-content')
            || this.querySelector('.js-currency-switcher-content, .js-language-switcher-content'),

    };

    this._suppressFocusOpen = false;

    this.elements.button.setAttribute('aria-expanded', 'false');
    this.elements.button.setAttribute('aria-haspopup', 'listbox');

    this.toggleSelector   = this.toggleSelector.bind(this);
    this.onContainerKeyUp = this.onContainerKeyUp.bind(this);
    this.onFocusIn        = this.onFocusIn.bind(this);
    this.onFocusOut       = this.onFocusOut.bind(this);
    this.onPointerDownBtn = this.onPointerDownBtn.bind(this);
    this.onDocClick       = this.onDocClick.bind(this);
    this.onItemClick      = this.onItemClick.bind(this);

    this.elements.button.addEventListener('click', this.toggleSelector);
    this.elements.button.addEventListener('pointerdown', this.onPointerDownBtn);
    this.addEventListener('keyup', this.onContainerKeyUp);
    this.addEventListener('focusin', this.onFocusIn);
    this.addEventListener('focusout', this.onFocusOut);
    this.querySelectorAll('a').forEach(a => a.addEventListener('click', this.onItemClick));
    document.addEventListener('click', this.onDocClick, true); 
  }

  disconnectedCallback() {
    document.removeEventListener('click', this.onDocClick, true);
  }

  isOpen() { return this.elements.panel.classList.contains('active'); }
  openPanel() {
    if (!this.isOpen()) {
      this.elements.panel.classList.add('active');
      this.elements.button.setAttribute('aria-expanded', 'true');
    }
  }
  hidePanel() {
    if (this.isOpen()) {
      setTimeout(() => {
        this.elements.panel.classList.remove('active');
        this.elements.button.setAttribute('aria-expanded', 'false');
      }, 300);
    }
  }

  onPointerDownBtn() {
    this._suppressFocusOpen = true;
    clearTimeout(this._suppressTimer);
    this._suppressTimer = setTimeout(() => { this._suppressFocusOpen = false; }, 150);
  }

  onFocusIn(e) {
    if (this._suppressFocusOpen) return;
    this.openPanel();
  }

  onFocusOut(e) {
    if (!this.contains(e.relatedTarget)) this.hidePanel();
  }

  onDocClick(e) {
    if (!this.contains(e.target)) this.hidePanel();
  }

  onContainerKeyUp(e) {
    if ((e.key || e.code)?.toUpperCase() === 'ESCAPE') {
      this.hidePanel();
      this.elements.button.focus();
    }
  }

  onItemClick(e) {
    e.preventDefault();
    const form = this.querySelector('form');
    if (this.elements.input) {
      this.elements.input.value = e.currentTarget.dataset.value || '';
    }
    if (form) form.submit();
    this.hidePanel();
  }

  toggleSelector() {
    const willOpen = !this.isOpen();
    if (willOpen) this.openPanel(); else this.hidePanel();
    this.elements.button.focus();
  }
}

customElements.define('localization-form', LocalizationForm);